import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@babackapp/customer-ui/components/alert-dialog";
import { Button } from "@babackapp/customer-ui/components/button";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { usePublicCancelReturnRequest } from "@babackapp/private-api-client/client/use-public-cancel-return-request";
import { useNavigate } from "react-router-dom";

type Props = {
  returnRequestId: string;
};

export function CancelReturnSection({ returnRequestId }: Props) {
  const t = useCustomText();
  const navigate = useNavigate();
  const { mutate, isPending, purgeCancelledReturnRequest } =
    usePublicCancelReturnRequest();

  const handleConfirm = () => {
    mutate(
      { returnRequestId },
      {
        onSuccess: () => {
          // Leave the details route BEFORE touching the cache: the search
          // endpoint excludes cancelled returns, so the details page would no
          // longer find its return request and crash into the error boundary.
          navigate("../cancel-complete", { replace: true });
          void purgeCancelledReturnRequest(returnRequestId);
        },
      },
    );
  };

  return (
    <AlertDialog>
        <AlertDialogTrigger asChild>
          {/* cancel-return-button: stable hook for merchant custom CSS (La Fée Maraboutée hides it). */}
          <Button variant="link" size="sm" className="cancel-return-button">
            {t("returnRequests.details.cancelButton")}
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              {t("returnRequests.details.cancelDialog.title")}
            </AlertDialogTitle>
            <AlertDialogDescription>
              {t("returnRequests.details.cancelDialog.description")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction
              onClick={handleConfirm}
              disabled={isPending}
              variant="destructive"
            >
              {t("returnRequests.details.cancelDialog.confirm")}
            </AlertDialogAction>
            <AlertDialogCancel disabled={isPending}>
              {t("returnRequests.details.cancelDialog.dismiss")}
            </AlertDialogCancel>
          </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
  );
}
